// Keep comparison in a function so the bundler does not dead-code-eliminate
// Octopus `#{...}` placeholders before deploy-time substitution.
export const isFeatureFlagEnabled = (value: string | undefined): boolean => `${value}` === "true";
